import React, { useState, useRef, useCallback } from 'react';
import { colors, baseStyles } from './SharedUI';
import MarketScreener from './MarketScreener'; // [MỚI THÊM] Import MarketScreener
import SmartSignalRadar from './SmartSignalRadar'; // [MỚI THÊM] Import SmartSignalRadar
// import RealtimeDumpRadar from './RealtimeDumpRadar'; // [MỚI THÊM] Import RealtimeDumpRadar
import TopGainers from './Top20Gainers'; 
import TelegramAlert from './TelegramAlert';
import SmartCoinFilter from './SmartCoinFilter';
import SmartCoinFilterV2 from './SmartCoinFilterV2';
import TradingCompassSection from './TradingCompassSection';
import LiveMarketSection from './LiveMarketSection';
import SmartMoneySection from './SmartMoneySection';
import SmartMoneyFlowVelocityV2 from './SmartMoneyFlowVelocityV2';

export default function UltimateDashboard() {
  const [symbol, setSymbol] = useState('BTCUSDT');
  const [tempInput, setTempInput] = useState('BTCUSDT');

  const liveDataRef = useRef(null);
  const smartMoneyRef = useRef(null);

  const handleSearch = (e) => {
    if (e.key === 'Enter' && tempInput.trim() !== '') {
      setSymbol(tempInput.toUpperCase().trim());
    }
  };

  const handleSelectCoinFromGainers = useCallback((newSymbol) => {
    setSymbol(newSymbol);
    setTempInput(newSymbol);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div style={baseStyles.container}>
      {/* ================= HEADER ================= */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${colors.border}`, paddingBottom: '16px', marginBottom: '20px', flexWrap: 'wrap', gap: '16px' }}>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <h1 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>⚡ ULTIMATE TRADING RADAR</h1>
          <input style={baseStyles.input} value={tempInput} onChange={e => setTempInput(e.target.value)} onKeyDown={handleSearch} placeholder="Nhập mã + Enter" />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <TelegramAlert 
            symbol={symbol} 
            liveDataRef={liveDataRef} 
            smartMoneyRef={smartMoneyRef} 
          />
          <div style={baseStyles.liveBadge}><div style={baseStyles.dot}></div> LIVE SYSTEM: {symbol}</div>
        </div>

      </div>
      
      {/* [MỚI THÊM] Đặt MarketScreener ngay trên TopGainers */}
      <MarketScreener onOpenRadar={handleSelectCoinFromGainers} />
      <SmartSignalRadar onOpenRadar={handleSelectCoinFromGainers} />

      <TopGainers onSelectCoin={handleSelectCoinFromGainers} />
      <SmartCoinFilter onSelectCoin={handleSelectCoinFromGainers} />
      <SmartCoinFilterV2 onSelectCoin={handleSelectCoinFromGainers} />
      
      {/* <RealtimeDumpRadar symbol={symbol} /> */}
      <LiveMarketSection symbol={symbol} liveDataRef={liveDataRef} smartMoneyRef={smartMoneyRef} />
      <TradingCompassSection symbol={symbol} liveDataRef={liveDataRef} smartMoneyRef={smartMoneyRef} />
      <SmartMoneySection symbol={symbol} smartMoneyRef={smartMoneyRef} liveDataRef={liveDataRef} />
      <SmartMoneyFlowVelocityV2 symbol={symbol} smartMoneyRef={smartMoneyRef} liveDataRef={liveDataRef} />
    </div>
  );
}
